// main.js
// state.js
class $bfc59006cf644cf7$var$State {
    constructor(){
        this.teams = [];
        this.interactions = {};
        this.listeners = [];
        this.loadFromStorage();
    }
    // Team management
    addTeam(fullName, shortName, description) {
        if (!this.teams.some((team)=>team.shortName === shortName)) {
            this.teams.push({
                fullName: fullName,
                shortName: shortName,
                description: description
            });
            this.notifyListeners();
            this.saveToStorage();
            return true;
        }
        return false;
    }
    removeTeam(shortName) {
        this.teams = this.teams.filter((team)=>team.shortName !== shortName);
        delete this.interactions[shortName];
        Object.keys(this.interactions).forEach((t)=>{
            delete this.interactions[t][shortName];
        });
        this.notifyListeners();
        this.saveToStorage();
    }
    getTeams() {
        return [
            ...this.teams
        ];
    }
    // Interaction management
    updateInteraction(team1, team2, interactionType) {
        if (!this.interactions[team1]) this.interactions[team1] = {};
        this.interactions[team1][team2] = interactionType;
        this.notifyListeners();
        this.saveToStorage();
    }
    getInteractions() {
        return JSON.parse(JSON.stringify(this.interactions));
    }
    // Listener management
    addListener(listener) {
        this.listeners.push(listener);
    }
    notifyListeners() {
        this.listeners.forEach((listener)=>listener());
    }
    // Data persistence
    loadFromStorage() {
        try {
            const savedTeams = localStorage.getItem("teams");
            const savedInteractions = localStorage.getItem("interactions");
            if (savedTeams) this.teams = JSON.parse(savedTeams).map((team)=>{
                // Handle legacy data
                if (typeof team === "string") return {
                    fullName: team,
                    shortName: team.substring(0, 5),
                    description: ""
                };
                return team;
            });
            if (savedInteractions) this.interactions = JSON.parse(savedInteractions);
        } catch (error) {
            console.error("Error loading data from storage:", error);
        }
    }
    saveToStorage() {
        try {
            localStorage.setItem("teams", JSON.stringify(this.teams));
            localStorage.setItem("interactions", JSON.stringify(this.interactions));
        } catch (error) {
            console.error("Error saving data to storage:", error);
        }
    }
    // Bulk operations
    setTeams(teams) {
        this.teams = teams;
        this.notifyListeners();
    }
    setInteractions(interactions) {
        this.interactions = interactions;
        this.notifyListeners();
    }
    // Reset
    reset() {
        this.teams = [];
        this.interactions = {};
        localStorage.removeItem("teams");
        localStorage.removeItem("interactions");
        this.notifyListeners();
    }
}
const $bfc59006cf644cf7$export$ca000e230c0caa3e = new $bfc59006cf644cf7$var$State();





// iconManager.js
const $7e110dfd5e7c4eb3$export$df03f54e09e486fa = {
    facilitation: `
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="white" width="22" height="22">
        <path fill-rule="evenodd" d="M4.606 12.97a.75.75 0 0 1-.134 1.051 2.494 2.494 0 0 0-.93 2.437 2.494 2.494 0 0 0 2.437-.93.75.75 0 1 1 1.186.918 3.995 3.995 0 0 1-4.482 1.332.75.75 0 0 1-.461-.461 3.994 3.994 0 0 1 1.332-4.482.75.75 0 0 1 1.052.134Z" clip-rule="evenodd" />
    <path fill-rule="evenodd" d="M5.752 12A13.07 13.07 0 0 0 8 14.248v4.002c0 .414.336.75.75.75a5 5 0 0 0 4.797-6.414 12.984 12.984 0 0 0 5.45-10.848.75.75 0 0 0-.735-.735 12.984 12.984 0 0 0-10.849 5.45A5 5 0 0 0 1 11.25c.001.414.337.75.751.75h4.002ZM13 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" clip-rule="evenodd" />
   </svg>`,
    collaboration: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="white" width="20" height="20">
        <path d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 0 0 2.433 3.984L7.28 21.53A.75.75 0 0 1 6 21v-4.03a48.527 48.527 0 0 1-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979Z" />
        <path d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 15.75 7.5Z" />
    </svg>`,
    "x-as-a-service": `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="20" height="20">
    <path d="M1 12.5A4.5 4.5 0 0 0 5.5 17H15a4 4 0 0 0 1.866-7.539 3.504 3.504 0 0 0-4.504-4.272A4.5 4.5 0 0 0 4.06 8.235 4.502 4.502 0 0 0 1 12.5Z" />
    </svg>`
};
function $7e110dfd5e7c4eb3$export$a297fe855adfd36c(type) {
    return $7e110dfd5e7c4eb3$export$df03f54e09e486fa[type] || "";
}


const $311c0116f8fa796c$var$interactionTypes = [
    {
        value: "none",
        label: "None",
        color: "#999999",
        icon: ""
    },
    {
        value: "collaboration",
        label: "Collaboration",
        color: "#FF6B6B",
        icon: "collaboration"
    },
    {
        value: "x-as-a-service",
        label: "X-as-a-Service",
        color: "#4ECDC4",
        icon: "x-as-a-service"
    },
    {
        value: "facilitation",
        label: "Facilitation",
        color: "#FFA500",
        icon: "facilitation"
    }
];
class $311c0116f8fa796c$var$InteractionItem extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
    }
    static get observedAttributes() {
        return [
            "team1",
            "team2"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) this.render();
    }
    render() {
        const team1 = this.getAttribute("team1");
        const team2 = this.getAttribute("team2");
        const currentInteraction = $311c0116f8fa796c$export$d4b29c4d1542b2a6(team1, team2);
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    margin-bottom: 1rem;
                    font-family: inherit;
                }
                .interaction-container {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }
                .team-name {
                    font-weight: bold;
                    font-size: 1rem;
                    margin-bottom: 0.5rem;
                }
                .interaction-buttons {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                }
                .interaction-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0.5rem;
                    border: none;
                    border-radius: 0.25rem;
                    font-size: 0.875rem;
                    cursor: pointer;
                    transition: opacity 0.2s;
                    white-space: nowrap;
                    flex: 1 1 calc(25% - 0.5rem);
                    min-width: 120px;
                }
                .interaction-btn:hover {
                    opacity: 0.8;
                }
                .interaction-btn.active {
                    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
                    font-weight: bold;
                }
                .interaction-btn svg {
                    width: 1rem;
                    height: 1rem;
                    margin-right: 0.25rem;
                }
                @media (max-width: 640px) {
                    .interaction-btn {
                        flex: 1 1 calc(50% - 0.5rem);
                    }
                }
            </style>
            <div class="interaction-container">
                <span class="team-name">${team2}</span>
                <div class="interaction-buttons">
                    ${$311c0116f8fa796c$var$interactionTypes.map((type)=>`
                        <button class="interaction-btn ${currentInteraction === type.value ? "active" : ""}"
                                style="background-color: ${type.color}; color: white;"
                                data-value="${type.value}">
                            ${type.icon ? (0, $7e110dfd5e7c4eb3$export$a297fe855adfd36c)(type.icon) : ""}
                            ${type.label}
                        </button>
                    `).join("")}
                </div>
            </div>
        `;
        this.shadowRoot.querySelector(".interaction-buttons").addEventListener("click", (e)=>{
            if (e.target.closest(".interaction-btn")) {
                const button = e.target.closest(".interaction-btn");
                (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).updateInteraction(team1, team2, button.dataset.value);
                this.render();
            }
        });
    }
}
customElements.define("interaction-item", $311c0116f8fa796c$var$InteractionItem);
function $311c0116f8fa796c$export$4d6a2c68b1ed74fe() {
    const teams = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams();
    const selectedTeam = document.getElementById("teamSelect").value;
    const interactionList = document.getElementById("interactionList");
    interactionList.innerHTML = teams.filter((team)=>team.shortName !== selectedTeam).map((team)=>`<interaction-item team1="${selectedTeam}" team2="${team.shortName}"></interaction-item>`).join("");
}
function $311c0116f8fa796c$export$d4b29c4d1542b2a6(team1, team2) {
    const interactions = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getInteractions();
    return interactions[team1] && interactions[team1][team2] ? interactions[team1][team2] : "none";
}
function $311c0116f8fa796c$export$48eea208dfb19940(type) {
    const interactionType = $311c0116f8fa796c$var$interactionTypes.find((t)=>t.value === type);
    return interactionType ? interactionType.color : "#999999";
}
function $311c0116f8fa796c$export$29fe370eef2e2d8b(type) {
    const interactionType = $311c0116f8fa796c$var$interactionTypes.find((t)=>t.value === type);
    return interactionType ? interactionType.icon : "";
}



// Configurable constants
const $babae5cc4692d59c$var$config = {
    width: 800,
    height: 600,
    radius: 30,
    forceStrength: -1000,
    distance: 200,
    zoomExtent: [
        0.5,
        2
    ] // Min and Max zoom levels
};
/**
 * Appends an interaction icon (circle and SVG) to the given D3 group element.
 * @param {object} g - The D3 group selection.
 * @param {string} type - The interaction type.
 * @param {number} [x=0] - The x-offset for the icon position.
 */ function $babae5cc4692d59c$var$appendIcon(g, type, x = 0) {
    // Append a circle to hold the icon
    g.append("circle").attr("r", 15) // Circle size for all icons
    .attr("cx", x).attr("fill", (0, $311c0116f8fa796c$export$48eea208dfb19940)(type));
    const iconSvg = (0, $7e110dfd5e7c4eb3$export$a297fe855adfd36c)(type);
    if (iconSvg) // Append the SVG content inside the circle using foreignObject
    g.append("foreignObject").attr("x", x - 9) // Adjusted to fit inside the circle
    .attr("y", -9).attr("width", 24).attr("height", 24).html(iconSvg); // Insert the SVG icon
}
/**
 * Creates an icon group for a link, handling cases with interaction disagreements.
 * @param {object} g - The D3 group selection.
 * @param {string} type1 - The first interaction type.
 * @param {string} type2 - The second interaction type.
 */ function $babae5cc4692d59c$var$createIconGroup(g, type1, type2) {
    const x = -10;
    if (type1 !== "none" && type2 !== "none" && type1 !== type2) {
        // Handle disagreement case by appending both icons
        $babae5cc4692d59c$var$appendIcon(g, type1, x);
        $babae5cc4692d59c$var$appendIcon(g, type2, -x);
    } else {
        const type = type1 !== "none" ? type1 : type2;
        $babae5cc4692d59c$var$appendIcon(g, type);
    }
}
/**
 * Handles the visual representation of interaction disagreements.
 * @param {object} link - The D3 selection of the link.
 * @param {string} type1 - First team's interaction view.
 * @param {string} type2 - Second team's interaction view.
 */ function $babae5cc4692d59c$var$handleDisagreement(link, type1, type2) {
    if (type1 !== type2 && type1 !== "none" && type2 !== "none") link.attr("stroke", "#FF0000") // Red to highlight disagreement
    .attr("stroke-dasharray", "5,5") // Dashed line for disagreement
    .attr("stroke-width", 4); // Thicker line for disagreement
    else link.attr("stroke", (0, $311c0116f8fa796c$export$48eea208dfb19940)(type1 !== "none" ? type1 : type2)).attr("stroke-width", 3);
}
function $babae5cc4692d59c$export$37216315ed12ca69() {
    const svg = d3.select("#graph").attr("viewBox", `0 0 ${$babae5cc4692d59c$var$config.width} ${$babae5cc4692d59c$var$config.height}`).call(d3.zoom().scaleExtent($babae5cc4692d59c$var$config.zoomExtent).on("zoom", (event)=>{
        graphGroup.attr("transform", event.transform);
    }));
    svg.selectAll("*").remove();
    const { width: width, height: height, radius: radius, forceStrength: forceStrength, distance: distance } = $babae5cc4692d59c$var$config;
    const graphGroup = svg.append("g");
    const teams = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams();
    const interactions = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getInteractions();
    // Prepare nodes
    const nodes = teams.map((team)=>({
            id: team.shortName,
            name: team.fullName,
            shortName: team.shortName,
            x: Math.random() * (width - 2 * radius) + radius,
            y: Math.random() * (height - 2 * radius) + radius
        }));
    // Prepare links and identify differences
    const links = [];
    const differences = [];
    const processedLinks = new Set();
    for(let i = 0; i < teams.length; i++)for(let j = i + 1; j < teams.length; j++){
        const team1 = teams[i].shortName;
        const team2 = teams[j].shortName;
        const key = `${team1}-${team2}`;
        if (!processedLinks.has(key)) {
            const interaction1 = interactions[team1]?.[team2] || "none";
            const interaction2 = interactions[team2]?.[team1] || "none";
            if (interaction1 !== "none" || interaction2 !== "none") {
                links.push({
                    source: team1,
                    target: team2,
                    type1: interaction1,
                    type2: interaction2
                });
                if (interaction1 !== interaction2) differences.push({
                    team1: teams[i],
                    team2: teams[j],
                    type1: interaction1,
                    type2: interaction2
                });
            }
            processedLinks.add(key);
        }
    }
    // Initialize D3 force simulation
    const simulation = d3.forceSimulation(nodes).force("link", d3.forceLink(links).id((d)=>d.id).distance(distance)).force("charge", d3.forceManyBody().strength(forceStrength)).force("center", d3.forceCenter(width / 2, height / 2)).force("collision", d3.forceCollide().radius(radius + 10)); // Ensure nodes don’t overlap
    // Draw links
    const link = graphGroup.append("g").selectAll("g").data(links).join("g");
    link.append("line").each(function(d) {
        $babae5cc4692d59c$var$handleDisagreement(d3.select(this), d.type1, d.type2);
    });
    // Draw nodes
    const node = graphGroup.append("g").selectAll("g").data(nodes).join("g").call(d3.drag().on("start", (event, d)=>{
        if (!event.active) simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
    }).on("drag", (event, d)=>{
        d.fx = event.x;
        d.fy = event.y;
    }).on("end", (event, d)=>{
        if (!event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
    }));
    node.append("circle").attr("r", radius).attr("fill", "#e0e0e0").attr("stroke", "#000").attr("stroke-width", 2);
    node.append("text").text((d)=>d.shortName).attr("text-anchor", "middle").attr("dy", "0.3em").attr("font-family", "Arial, sans-serif").attr("font-size", "14px");
    // Add icons for interaction types
    const iconGroups = graphGroup.append("g").selectAll("g").data(links).join("g");
    iconGroups.each(function(d) {
        $babae5cc4692d59c$var$createIconGroup(d3.select(this), d.type1, d.type2);
    });
    // Simulation tick event
    simulation.on("tick", ()=>{
        link.selectAll("line").attr("x1", (d)=>d.source.x).attr("y1", (d)=>d.source.y).attr("x2", (d)=>d.target.x).attr("y2", (d)=>d.target.y);
        node.attr("transform", (d)=>`translate(${d.x},${d.y})`);
        iconGroups.attr("transform", (d)=>`translate(${(d.source.x + d.target.x) / 2},${(d.source.y + d.target.y) / 2})`);
    });
    // Display differences in interaction perceptions
    const differenceList = document.getElementById("differenceList");
    if (differenceList) differenceList.innerHTML = differences.length > 0 ? `<h3 class="text-xl font-semibold mb-2">Interaction Differences:</h3>` + differences.map((diff)=>`
                <p>${diff.team1.fullName} (${diff.team1.shortName}) sees ${diff.team2.fullName} (${diff.team2.shortName}) as ${diff.type1}, but ${diff.team2.fullName} (${diff.team2.shortName}) sees ${diff.team1.fullName} (${diff.team1.shortName}) as ${diff.type2}.</p>
            `).join("") : "<p>No differences detected.</p>";
}



const $476b01cf533515ba$var$interactionTypes = [
    {
        value: "none",
        label: "None",
        color: "#999999",
        icon: ""
    },
    {
        value: "collaboration",
        label: "Collaboration",
        color: "#FF6B6B",
        icon: "collaboration"
    },
    {
        value: "x-as-a-service",
        label: "X-as-a-Service",
        color: "#4ECDC4",
        icon: "x-as-a-service"
    },
    {
        value: "facilitation",
        label: "Facilitation",
        color: "#FFA500",
        icon: "facilitation"
    }
];
function $476b01cf533515ba$export$5f1a586fc99d1fc2() {
    const teams = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams();
    const teamList = document.getElementById("teamList");
    teamList.innerHTML = teams.map((team)=>`
        <div class="team-card">
            <div class="flex justify-between items-start">
                <div>
                    <h3>
                        <span class="team-full-name">${team.fullName}</span>
                        <span class="team-short-name">(${team.shortName})</span>
                    </h3>
                    <p class="team-description">${team.description || "No description provided"}</p>
                </div>
                <button class="remove-team-btn text-red-500 hover:text-red-700 transition-colors duration-200" data-team="${team.shortName}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    `).join("");
    teamList.querySelectorAll(".remove-team-btn").forEach((button)=>{
        button.addEventListener("click", ()=>{
            const teamShortName = button.dataset.team;
            const teamToRemove = teams.find((team)=>team.shortName === teamShortName);
            if (confirm(`Are you sure you want to remove the team "${teamToRemove.fullName} (${teamToRemove.shortName})"?`)) {
                (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).removeTeam(teamShortName);
                $476b01cf533515ba$export$5f1a586fc99d1fc2();
                $476b01cf533515ba$var$updateTeamSelect();
            }
        });
    });
    $476b01cf533515ba$var$updateTeamSelect();
}
function $476b01cf533515ba$var$updateTeamSelect() {
    const teams = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams();
    const teamSelect = document.getElementById("teamSelect");
    const currentSelection = teamSelect.value;
    teamSelect.innerHTML = teams.map((team)=>`<option value="${team.shortName}">${team.fullName} (${team.shortName})</option>`).join("");
    if (teams.some((team)=>team.shortName === currentSelection)) teamSelect.value = currentSelection;
    else if (teams.length > 0) teamSelect.value = teams[0].shortName;
    $476b01cf533515ba$export$4d6a2c68b1ed74fe();
}
function $476b01cf533515ba$export$4d6a2c68b1ed74fe() {
    const teams = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams();
    const interactions = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getInteractions();
    const selectedTeam = document.getElementById("teamSelect").value;
    const interactionList = document.getElementById("interactionList");
    interactionList.innerHTML = teams.filter((team)=>team.shortName !== selectedTeam).map((team)=>{
        const currentInteraction = interactions[selectedTeam] && interactions[selectedTeam][team.shortName] ? interactions[selectedTeam][team.shortName] : "none";
        return `
                <div class="interaction-item">
                    <div class="team-info">
                        <span class="text-gray-800 font-medium">${team.fullName} (${team.shortName})</span>
                    </div>
                    <div class="interaction-buttons" data-team1="${selectedTeam}" data-team2="${team.shortName}">
                        ${$476b01cf533515ba$var$interactionTypes.map((type)=>`
                            <button class="interaction-btn ${currentInteraction === type.value ? "active" : ""}"
                                    data-type="${type.value}">
                                ${(0, $7e110dfd5e7c4eb3$export$a297fe855adfd36c)(type.icon)}
                                <span>${type.label}</span>
                            </button>
                        `).join("")}
                    </div>
                </div>
            `;
    }).join("");
    interactionList.querySelectorAll(".interaction-buttons").forEach((buttonGroup)=>{
        buttonGroup.addEventListener("click", (e)=>{
            if (e.target.closest(".interaction-btn")) {
                const button = e.target.closest(".interaction-btn");
                const type = button.dataset.type;
                const team1 = buttonGroup.dataset.team1;
                const team2 = buttonGroup.dataset.team2;
                (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).updateInteraction(team1, team2, type);
                buttonGroup.querySelectorAll(".interaction-btn").forEach((btn)=>btn.classList.remove("active"));
                button.classList.add("active");
            }
        });
    });
}
function $476b01cf533515ba$export$17f3d25eed773ff1(stepId) {
    document.querySelectorAll(".step-content").forEach((step)=>step.classList.add("hidden"));
    document.getElementById(stepId).classList.remove("hidden");
    document.querySelectorAll(".btn-nav").forEach((btn)=>btn.classList.remove("active"));
    document.querySelector(`.btn-nav[data-step="${stepId}"]`).classList.add("active");
    if (stepId === "step2") $476b01cf533515ba$export$4d6a2c68b1ed74fe();
    else if (stepId === "step3") (0, $babae5cc4692d59c$export$37216315ed12ca69)();
}
// Initialize event listeners
document.addEventListener("DOMContentLoaded", ()=>{
    document.getElementById("addTeamForm").addEventListener("submit", (e)=>{
        e.preventDefault();
        const fullNameInput = document.getElementById("teamFullName");
        const shortNameInput = document.getElementById("teamShortName");
        const descriptionInput = document.getElementById("teamDescription");
        if (fullNameInput && shortNameInput) {
            const fullName = fullNameInput.value.trim();
            const shortName = shortNameInput.value.trim();
            const description = descriptionInput ? descriptionInput.value.trim() : "";
            if (fullName && shortName) {
                if ((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).addTeam(fullName, shortName, description)) {
                    fullNameInput.value = "";
                    shortNameInput.value = "";
                    if (descriptionInput) descriptionInput.value = "";
                    $476b01cf533515ba$var$showNotification("Team added successfully!", "success");
                } else $476b01cf533515ba$var$showNotification("A team with this short name already exists.", "error");
            }
        } else console.error("Team input fields not found");
    });
    document.querySelectorAll(".btn-nav").forEach((btn)=>{
        btn.addEventListener("click", ()=>$476b01cf533515ba$export$17f3d25eed773ff1(btn.dataset.step));
    });
    document.getElementById("teamSelect").addEventListener("change", $476b01cf533515ba$export$4d6a2c68b1ed74fe);
    document.getElementById("toggleDifferences").addEventListener("click", ()=>{
        const differenceList = document.getElementById("differenceList");
        const toggleButton = document.getElementById("toggleDifferences");
        if (differenceList.classList.contains("hidden")) {
            differenceList.classList.remove("hidden");
            toggleButton.textContent = "Hide Differences";
        } else {
            differenceList.classList.add("hidden");
            toggleButton.textContent = "Show Differences";
        }
    });
    const resetButton = document.getElementById("resetButton");
    resetButton.addEventListener("click", ()=>{
        if (confirm("Are you sure you want to reset all data? This action cannot be undone.")) {
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).reset();
            $476b01cf533515ba$export$5f1a586fc99d1fc2();
            $476b01cf533515ba$var$showNotification("All data has been reset.", "success");
        }
    });
    // Add Download State button
    const downloadButton = document.createElement("button");
    downloadButton.textContent = "Download State";
    downloadButton.id = "downloadButton";
    downloadButton.className = "btn-nav ml-2";
    downloadButton.addEventListener("click", ()=>{
        const stateData = {
            source_url: "www.team-interactions.app",
            teams: (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams(),
            interactions: (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getInteractions()
        };
        const stateJson = JSON.stringify(stateData, null, 2);
        const blob = new Blob([
            stateJson
        ], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "team-interactions-state.json";
        a.click();
        URL.revokeObjectURL(url);
    });
    // Add Upload State button and functionality
    const uploadButton = document.createElement("button");
    uploadButton.textContent = "Upload State";
    uploadButton.id = "uploadButton";
    uploadButton.className = "btn-nav ml-2";
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "application/json";
    fileInput.style.display = "none";
    uploadButton.addEventListener("click", ()=>fileInput.click());
    fileInput.addEventListener("change", (event)=>{
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e)=>{
                try {
                    const uploadedState = JSON.parse(e.target.result);
                    if (uploadedState.source_url === "www.team-interactions.app" && uploadedState.teams && uploadedState.interactions) {
                        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setTeams(uploadedState.teams);
                        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setInteractions(uploadedState.interactions);
                        $476b01cf533515ba$export$5f1a586fc99d1fc2();
                        $476b01cf533515ba$export$4d6a2c68b1ed74fe();
                        $476b01cf533515ba$var$showNotification("State uploaded successfully!", "success");
                    } else throw new Error("Invalid state file");
                } catch (error) {
                    $476b01cf533515ba$var$showNotification("Error uploading state: Invalid file format", "error");
                }
            };
            reader.readAsText(file);
        }
    });
    // Create a container for the buttons
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "flex justify-center mt-8";
    // Move the reset button into the container instead of replacing it
    resetButton.parentNode.insertBefore(buttonContainer, resetButton);
    buttonContainer.appendChild(downloadButton);
    buttonContainer.appendChild(uploadButton);
    buttonContainer.appendChild(resetButton);
    document.body.appendChild(fileInput);
    $476b01cf533515ba$export$5f1a586fc99d1fc2();
});
function $476b01cf533515ba$var$showNotification(message, type) {
    const notification = document.createElement("div");
    notification.textContent = message;
    notification.className = `fixed bottom-4 right-4 px-4 py-2 rounded-md text-white ${type === "success" ? "bg-green-500" : "bg-red-500"}`;
    document.body.appendChild(notification);
    setTimeout(()=>{
        notification.remove();
    }, 3000);
}



// package.json
var $0dea53fbf8dad186$var$name = "@vercel/analytics";
var $0dea53fbf8dad186$var$version = "1.3.1";
// src/queue.ts
var $0dea53fbf8dad186$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $0dea53fbf8dad186$var$isBrowser() {
    return typeof window !== "undefined";
}
function $0dea53fbf8dad186$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $0dea53fbf8dad186$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $0dea53fbf8dad186$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $0dea53fbf8dad186$var$getMode() {
    const mode = $0dea53fbf8dad186$var$isBrowser() ? window.vam : $0dea53fbf8dad186$var$detectEnvironment();
    return mode || "production";
}
function $0dea53fbf8dad186$var$isProduction() {
    return $0dea53fbf8dad186$var$getMode() === "production";
}
function $0dea53fbf8dad186$var$isDevelopment() {
    return $0dea53fbf8dad186$var$getMode() === "development";
}
function $0dea53fbf8dad186$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $0dea53fbf8dad186$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $0dea53fbf8dad186$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
// src/generic.ts
var $0dea53fbf8dad186$export$cc0e5e1940903e90 = "https://va.vercel-scripts.com/v1/script.debug.js";
var $0dea53fbf8dad186$export$d8034046b3b05009 = "/_vercel/insights/script.js";
function $0dea53fbf8dad186$export$a976684a0efeb93f(props = {
    debug: true
}) {
    var _a;
    if (!$0dea53fbf8dad186$var$isBrowser()) return;
    $0dea53fbf8dad186$var$setMode(props.mode);
    $0dea53fbf8dad186$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = props.scriptSrc || ($0dea53fbf8dad186$var$isDevelopment() ? $0dea53fbf8dad186$export$cc0e5e1940903e90 : $0dea53fbf8dad186$export$d8034046b3b05009);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $0dea53fbf8dad186$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $0dea53fbf8dad186$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $0dea53fbf8dad186$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($0dea53fbf8dad186$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $0dea53fbf8dad186$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$0dea53fbf8dad186$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($0dea53fbf8dad186$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $0dea53fbf8dad186$var$parseProperties(properties, {
            strip: $0dea53fbf8dad186$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $0dea53fbf8dad186$var$isDevelopment()) console.error(err);
    }
}
function $0dea53fbf8dad186$export$b81f1580747d8b3a({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
var $0dea53fbf8dad186$export$2e2bcd8739ae039 = {
    inject: $0dea53fbf8dad186$export$a976684a0efeb93f,
    track: $0dea53fbf8dad186$export$6b2a7d5132615086
};


const $2b6e161c9edcf319$var$STEPS = {
    ADD_TEAMS: "step1",
    DEFINE_INTERACTIONS: "step2",
    VIEW_GRAPH: "step3"
};
document.addEventListener("DOMContentLoaded", ()=>{
    console.log("DOM fully loaded");
    // Load the initial state
    (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).loadFromStorage();
    console.log("Initial state loaded:", (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams());
    // Set up the state change listener
    (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).addListener(()=>{
        console.log("State changed, updating UI");
        (0, $476b01cf533515ba$export$5f1a586fc99d1fc2)();
        (0, $476b01cf533515ba$export$4d6a2c68b1ed74fe)();
        if (document.getElementById($2b6e161c9edcf319$var$STEPS.VIEW_GRAPH).classList.contains("hidden") === false) (0, $babae5cc4692d59c$export$37216315ed12ca69)(); // Redraw the graph if it's currently visible
        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).saveToStorage();
    });
    // Set up UI event listeners
    document.getElementById("addTeamsBtn").addEventListener("click", ()=>(0, $476b01cf533515ba$export$17f3d25eed773ff1)($2b6e161c9edcf319$var$STEPS.ADD_TEAMS));
    document.getElementById("defineInteractionsBtn").addEventListener("click", ()=>(0, $476b01cf533515ba$export$17f3d25eed773ff1)($2b6e161c9edcf319$var$STEPS.DEFINE_INTERACTIONS));
    document.getElementById("viewGraphBtn").addEventListener("click", ()=>(0, $476b01cf533515ba$export$17f3d25eed773ff1)($2b6e161c9edcf319$var$STEPS.VIEW_GRAPH));
    document.getElementById("addTeamForm").addEventListener("submit", (e)=>{
        e.preventDefault();
        const fullNameInput = document.getElementById("teamFullName");
        const shortNameInput = document.getElementById("teamShortName");
        const descriptionInput = document.getElementById("teamDescription");
        if (fullNameInput && shortNameInput) {
            const fullName = fullNameInput.value.trim();
            const shortName = shortNameInput.value.trim();
            const description = descriptionInput ? descriptionInput.value.trim() : "";
            if (fullName && shortName) {
                if ((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).addTeam(fullName, shortName, description)) {
                    fullNameInput.value = "";
                    shortNameInput.value = "";
                    if (descriptionInput) descriptionInput.value = "";
                    console.log("Team added:", fullName, shortName);
                } else console.log("Failed to add team:", fullName, shortName);
            }
        } else console.error("Team input fields not found");
    });
    document.getElementById("teamSelect").addEventListener("change", (0, $476b01cf533515ba$export$4d6a2c68b1ed74fe));
    // Initial renders
    console.log("Performing initial renders");
    (0, $476b01cf533515ba$export$5f1a586fc99d1fc2)();
    (0, $476b01cf533515ba$export$4d6a2c68b1ed74fe)();
});
// Analytics
(0, $0dea53fbf8dad186$export$a976684a0efeb93f)();
// Expose some functions to the global scope for debugging
window.debugState = ()=>console.log((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTeams(), (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getInteractions());


//# sourceMappingURL=index.eec86307.js.map
